export default "__VITE_ASSET__QO31WUlj__"